import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, filter, map, take } from 'rxjs';
import { UserProviderService } from '@valtimo/security';

@Injectable({
    providedIn: 'root',
})
export class AuthGuardService implements CanActivate {

    private readonly allowedRoles = [
        'ROLE_ADMIN',
        'ALFRESCO_ADMINISTRATOR',
    ];

    constructor(
        private readonly userProviderService: UserProviderService,
        private readonly router: Router
    ) { }

    canActivate(): Observable<boolean | UrlTree> {
        return this.userProviderService.getUserSubject().pipe(
            // Wait until Keycloak has populated the user
            filter(user => !!user && Array.isArray(user.roles)),
            take(1),

            map(user => {
                const allowed = user.roles.some(role =>
                    this.allowedRoles.includes(role)
                );

                // 🔑 Redirect instead of returning false
                return allowed
                    ? true
                    : this.router.createUrlTree(['/forbidden']);
            })
        );
    }
}
